import { render, staticRenderFns } from "./virescene.vue?vue&type=template&id=d285539a&scoped=true&"
import script from "./virescene.vue?vue&type=script&lang=js&"
export * from "./virescene.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d285539a",
  null
  
)

export default component.exports